module.exports = __webpack_public_path__ + "img/IMG_8226.36f16811.jpg";